import {
  useQuery,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'

import { scenarioQueryKeys } from '../queryKeys'
import { singularResourcefulScenarioRequest } from '../requests'

export function useFnaQuery({
  scenarioID,
  initialData,
  queryKey
}) {
  const queryClient = useQueryClient()

  const fnaRequest = singularResourcefulScenarioRequest(
    scenarioID, 'financial_needs_analysis'
  )

  const fnaQuery = useQuery({
    queryFn: fnaRequest.show,
    queryKey,
    initialData
  })

  const updateFnaMutation = useMutation({
    mutationFn: fnaRequest.update,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).fna] })
    },

  })


  const isFetching = fnaQuery.isFetching || updateFnaMutation.isLoading

  const isAnyLoading = fnaQuery.isFetching ||
    updateFnaMutation.isLoading

  return {
    data: fnaQuery.data,
    actions: {
      update: updateFnaMutation.mutateAsync,
    },
    status: fnaQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
